import { Injectable } from '@angular/core';
import { ModuleAccessService } from '../../system-services/ModuleAccess/ModuleAccess.service';

@Injectable({ providedIn: 'root' })
export class NonSelfServeModulesOnly {
    constructor(private moduleAccess: ModuleAccessService) {}

    canActivate() {
        return !this.moduleAccess.hasAnySelfServeModule;
    }

    canActivateChild(): boolean {
        return this.canActivate();
    }
}
